module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-arrow-light-new-f2ce5cd3d199a5cfa4ce4f9a115e7ee5.svg";